import type { Dictionary } from './en';

export const it: Dictionary = {
  'common.cancel': 'Annulla',
  'common.back': 'Indietro',
  'common.retry': 'Riprova',
  'common.copy': 'Copia',
  'common.copied': 'Copiato',
  'common.share': 'Condividi',
  'common.delete': 'Elimina',
  'common.revoke': 'Revoca',
  'common.close': 'Chiudi',
  'common.loading': 'Caricamento',
  'common.optional': 'Facoltativo',
  'common.or': 'oppure',
  'common.none': 'Nessuno',
  'common.required': 'Obbligatorio',
  'common.notSet': 'Non impostato',
  'common.skipToContent': 'Vai al contenuto principale',
  'common.moment': 'Un attimo…',

  'brand.tagline': 'Condividi un video. Una sola volta.',
  'brand.home': 'BOOMSHOT - home',
  'brand.footerLimit':
    'BOOMSHOT garantisce una riproduzione unica sicura. Nessuna tecnologia può impedire uno screenshot o una registrazione dello schermo.',

  'nav.main': 'Navigazione principale',
  'nav.myVideos': 'I miei video',
  'nav.privacy': 'Privacy',
  'nav.signIn': 'Accedi',
  'nav.signOut': 'Esci',
  'nav.settings': "Impostazioni dell'account",
  'nav.openMenu': 'Apri il menu',
  'nav.closeMenu': 'Chiudi il menu',

  'theme.light': 'Tema chiaro - passa a scuro',
  'theme.dark': 'Tema scuro - passa ad automatico',
  'theme.system': 'Tema automatico - passa a chiaro',
  'theme.label': 'Aspetto',
  'theme.optionSystem': 'Automatico',
  'theme.optionLight': 'Chiaro',
  'theme.optionDark': 'Scuro',

  'language.label': 'Lingua',
  'language.change': 'Cambia lingua',

  'landing.title': 'Condividi un video. Una sola volta.',
  'landing.subtitle':
    'Il tuo link privato smette di funzionare dopo la prima visione e il video viene eliminato automaticamente.',
  'landing.ctaNew': 'Crea un link privato',
  'landing.ctaSend': 'Invia un video',
  'landing.haveAccount': 'Ho già un account',
  'landing.assure.encrypted': 'Cifrato in transito',
  'landing.assure.deleted': 'Eliminato dopo la visione',
  'landing.assure.noReplay': 'Nessun replay',
  'landing.how': 'Tre passaggi. Nessuna seconda occasione.',
  'landing.step1.title': 'Invia',
  'landing.step1.body':
    'Trascina un video. Viene convertito in frammenti serviti da uno storage privato, mai da un URL pubblico.',
  'landing.step2.title': 'Configura',
  'landing.step2.body':
    'Scadenza, codice di accesso, filigrana, messaggio. Il link porta un segreto che non lascia mai il tuo dispositivo.',
  'landing.step3.title': 'Una sola visione',
  'landing.step3.body':
    'La prima sessione riserva il link in modo definitivo. Al termine i file vengono distrutti lato server.',
  'landing.limits.title': 'Cosa fa BOOMSHOT',
  'landing.limits.guaranteed': 'Garantito lato server',
  'landing.limits.g1': 'Una sola sessione di riproduzione per link, riservata in modo atomico.',
  'landing.limits.g2': 'Frammenti serviti con token di breve durata, senza URL permanente.',
  'landing.limits.g3':
    'Eliminazione verificata del file sorgente, dei frammenti e delle miniature.',

  'auth.signIn.title': 'Accedi',
  'auth.signIn.subtitle': 'Accedi ai tuoi video e ai tuoi link attivi.',
  'auth.signIn.submit': 'Accedi',
  'auth.signIn.noAccount': 'Non hai ancora un account?',
  'auth.signIn.create': 'Crea un account',
  'auth.signIn.magicLink': 'Ricevi un link di accesso',
  'auth.signIn.usePassword': 'Usa una password',
  'auth.signIn.forgot': 'Password dimenticata',
  'auth.signIn.magicSent':
    'Se esiste un account con questo indirizzo, abbiamo appena inviato un link di accesso. Funziona una sola volta.',
  'auth.signUp.title': 'Crea un account',
  'auth.signUp.subtitle':
    'Serve un account per inviare. I tuoi destinatari non ne hanno mai bisogno.',
  'auth.signUp.submit': 'Crea il mio account',
  'auth.signUp.hasAccount': 'Già registrato?',
  'auth.signUp.terms':
    'Ho capito che un video riprodotto in un browser può sempre essere catturato con una registrazione dello schermo e che BOOMSHOT garantisce una riproduzione unica, non una protezione anticopia.',
  'auth.reset.title': 'Password dimenticata',
  'auth.reset.subtitle': 'Ti invieremo un link per reimpostarla.',
  'auth.reset.submit': 'Invia il link',
  'auth.reset.sent':
    'Se esiste un account con questo indirizzo, abbiamo appena inviato un’email di reimpostazione. Controlla anche la posta indesiderata.',
  'auth.reset.back': "Torna all'accesso",
  'auth.callback.title': 'Accesso in corso',
  'auth.callback.subtitle': 'Verifica del tuo link…',
  'auth.callback.invalid': 'Questo non è un link di accesso valido.',
  'auth.callback.requestNew': 'Richiedi un nuovo link',
  'auth.google': 'Continua con Google',
  'auth.email': 'Indirizzo email',
  'auth.emailPlaceholder': 'tu@esempio.com',
  'auth.password': 'Password',
  'auth.passwordConfirm': 'Conferma la password',
  'auth.passwordHint': 'Almeno 10 caratteri, con maiuscola, minuscola e cifra.',
  'auth.magicHint': 'Riceverai un link monouso, senza password.',
  'auth.confirmEmailPrompt': "Conferma il tuo indirizzo email per completare l'accesso",

  'authError.invalidCredential': 'Indirizzo email o password errati.',
  'authError.emailInUse':
    'Non è stato possibile creare questo account. Prova ad accedere o a reimpostare la password.',
  'authError.weakPassword': 'Password troppo debole.',
  'authError.tooManyRequests': 'Troppi tentativi. Riprova tra qualche minuto.',
  'authError.network': 'Nessuna connessione. Controlla la rete.',
  'authError.popupClosed': "La finestra è stata chiusa prima di completare l'accesso.",
  'authError.popupBlocked': 'Il browser ha bloccato la finestra.',
  'authError.recentLogin': 'Per sicurezza, accedi di nuovo prima di continuare.',
  'authError.invalidActionCode': 'Questo link di accesso non è valido o è già stato usato.',
  'authError.expiredActionCode': 'Questo link di accesso è scaduto. Richiedine uno nuovo.',
  'authError.generic': 'Qualcosa è andato storto. Riprova.',

  'dashboard.title': 'I miei video',
  'dashboard.subtitle': 'Ogni link consente esattamente una sessione di riproduzione.',
  'dashboard.send': 'Invia un video',
  'dashboard.metric.activeLinks': 'Link attivi',
  'dashboard.metric.watched': 'Video visti',
  'dashboard.metric.storage': 'Spazio temporaneo',
  'dashboard.search': 'Cerca',
  'dashboard.searchPlaceholder': 'Cerca per nome o destinatario',
  'dashboard.filters': 'Filtri',
  'dashboard.filterStatus': 'Stato',
  'dashboard.filterAll': 'Tutti gli stati',
  'dashboard.sort': 'Ordinamento',
  'dashboard.sortNewest': 'Più recenti',
  'dashboard.sortOldest': 'Meno recenti',
  'dashboard.sortExpiring': 'In scadenza',
  'dashboard.empty.title': 'Ancora nessun video',
  'dashboard.empty.body':
    'Invia il tuo primo video: verrà convertito, protetto da un link monouso e poi eliminato dopo la prima visione.',
  'dashboard.noResults.title': 'Nessun risultato',
  'dashboard.noResults.body':
    'Nessun video corrisponde a questa ricerca. Prova un altro termine o azzera i filtri.',
  'dashboard.loadError': 'Impossibile caricare i tuoi video. Controlla la connessione.',
  'dashboard.loadBlocked': 'Impossibile caricare i tuoi video. Il servizio non è configurato correttamente - non dipende da te.',
  'dashboard.expiresIn': 'Scade {when}',
  'dashboard.viewedAt': 'Visto {when}',
  'dashboard.createdAt': 'Creato {when}',
  'dashboard.forRecipient': 'Per {name}',

  'status.processing': 'In elaborazione',
  'status.ready': 'Pronto',
  'status.opened': 'Link aperto',
  'status.playing': 'In riproduzione',
  'status.watched': 'Visto',
  'status.expired': 'Scaduto',
  'status.deleted': 'Eliminato',
  'status.error': 'Errore',

  'upload.title': 'Invia un video',
  'upload.subtitle':
    'Verrà convertito, protetto da un link monouso e poi eliminato dopo la prima visione.',
  'upload.drop': 'Trascina qui il tuo video',
  'upload.formats': '{formats} - fino a {size}',
  'upload.choose': 'Scegli un file',
  'upload.progress': "Avanzamento dell'invio",
  'upload.inProgress': 'Invio in corso…',
  'upload.converting': 'Conversione in corso…',
  'upload.cancelUpload': "Annulla l'invio",
  'upload.processingNote':
    'Conversione in frammenti sicuri. Non serve aspettare: genera subito il link, funzionerà appena questa fase sarà completata.',
  'upload.restart': 'Ricomincia',
  'upload.error.format': 'Formato non supportato. Usa un file MP4, MOV o WebM.',
  'upload.error.tooLarge': 'File troppo grande (massimo {size}).',
  'upload.error.notVideo': 'Questo file non sembra un video valido.',
  'upload.error.unreadable': 'Non è stato possibile leggere questo file come video.',
  'upload.error.tooLong': 'Video troppo lungo ({duration}). Massimo {max}.',
  'upload.error.failed': "L'invio non è riuscito. Controlla la connessione e riprova.",
  'upload.error.transcode':
    'La conversione di questo video non è riuscita. Il file è stato eliminato. Prova un altro formato.',
  'upload.error.tracking': "Monitoraggio dell'elaborazione interrotto. Ricarica la pagina.",

  'config.expiry': 'Scadenza del link',
  'config.expiry1h': '1 ora',
  'config.expiry24h': '24 h',
  'config.expiry3d': '3 giorni',
  'config.expiry7d': '7 giorni',
  'config.expiryCustom': 'Data personalizzata',
  'config.expiryDate': 'Data e ora di scadenza',
  'config.pin': 'Codice di accesso',
  'config.pinHint': 'Da 4 a 8 cifre. Invialo separatamente dal link.',
  'config.advanced': 'Opzioni avanzate',
  'config.internalName': 'Nome interno',
  'config.internalNameHint': 'Visibile solo a te, mai al destinatario.',
  'config.recipient': 'Nome del destinatario',
  'config.recipientHint': 'Mostrato nella filigrana quando è attiva.',
  'config.watermark': 'Filigrana',
  'config.watermarkNone': 'Nessuna',
  'config.watermarkSubtle': 'Discreta',
  'config.watermarkReinforced': 'Rinforzata',
  'config.message': 'Messaggio al destinatario',
  'config.messagePlaceholder': 'Facoltativo - mostrato prima della riproduzione',
  'config.submit': 'Crea il link privato',
  'config.alwaysDeleted':
    "L'eliminazione dopo la visione è sempre attiva e non può essere disattivata.",
  'config.linkFailed': 'Impossibile generare il link.',

  'ready.eyebrow': 'Link generato',
  'ready.title': 'Il tuo link è pronto. Funziona una volta sola.',
  'ready.meta': '{name} · {duration} · scade il {date}',
  'ready.stillProcessing':
    'Questo link funziona già, ma il video è ancora in elaborazione. Se viene aperto subito, il destinatario dovrà solo attendere un momento.',
  'ready.secureLink': 'Link sicuro',
  'ready.copyFailed': 'Copia non riuscita. Seleziona il link manualmente.',
  'ready.shareTitle': 'Video a visione unica',
  'ready.shareText': 'Questo video può essere visto una sola volta.',
  'ready.pinWarning':
    'Il codice di accesso è volutamente escluso dalla condivisione. Trasmettilo su un altro canale (SMS, telefonata), mai nello stesso messaggio del link.',
  'ready.fragmentNote':
    'La parte del link dopo il {hash} è il segreto di accesso. Non viene mai inviata ai nostri server: copia il link per intero.',
  'ready.protections': 'Protezioni attive',
  'ready.protectionSingle': 'Una sola sessione di riproduzione',
  'ready.protectionDelete': 'Eliminazione dopo la visione',
  'ready.protectionPin': 'Codice di accesso richiesto',
  'ready.protectionsNote':
    'Queste misure garantiscono una riproduzione unica. Non possono impedire uno screenshot o una registrazione dello schermo.',
  'ready.qr': 'Codice QR',
  'ready.qrAlt': 'Codice QR del link sicuro per {name}',
  'ready.sendAnother': 'Invia un altro video',
  'ready.backToDashboard': 'Torna alla dashboard',
  'ready.leaveWarnTitle': 'Non hai ancora copiato questo link',
  'ready.leaveWarnBody':
      "È l'unica volta che viene mostrato. Non è salvato da nessuna parte: se esci ora senza copiarlo o condividerlo, nessuno - nemmeno tu - potrà più recuperarlo. Dovresti revocare il link di questo video e inviarlo di nuovo.",
  'ready.leaveAnyway': 'Esci senza copiare',
  'ready.copyNow': 'Copia il link',
  'ready.watermarkNone': 'Nessuna filigrana',
  'ready.watermarkSubtle': 'Filigrana discreta',
  'ready.watermarkReinforced': 'Filigrana rinforzata',

  'detail.notFound.title': 'Video non trovato',
  'detail.notFound.body': 'Questo video non esiste più oppure non ti appartiene.',
  'detail.duration': 'Durata',
  'detail.size': 'Dimensione',
  'detail.created': 'Creato il',
  'detail.recipient': 'Destinatario',
  'detail.expiry': 'Scadenza',
  'detail.viewedOn': 'Visto il',
  'detail.deletedOn': 'Eliminato il',
  'detail.pinRequired': 'Richiesto',
  'detail.consumedNote':
    'Questo video è stato visto. Il link è definitivamente inutilizzabile e i file sono stati eliminati dallo storage.',
  'detail.failedNote':
    "L'elaborazione di questo video non è riuscita. Non è stato generato alcun link e i file temporanei sono stati eliminati.",
  'detail.lastError': 'Ultimo errore segnalato dal server:',
  'detail.copyLink': 'Copia il link',
  'detail.secretLost':
    'Il segreto del link non viene mai memorizzato: compare solo alla generazione. Revoca questo link e creane uno nuovo se lo hai perso.',
  'detail.revoke': 'Revoca il link',
  'detail.deleteNow': 'Elimina adesso',
  'detail.reuse': 'Riutilizza queste impostazioni',
  'detail.revokeTitle': 'Revocare questo link?',
  'detail.revokeBody':
    'Il link smetterà di funzionare immediatamente. Il video verrà poi eliminato.',
  'detail.revoked': 'Link revocato.',
  'detail.deleteTitle': 'Eliminare questo video?',
  'detail.deleteBody':
    'Il file sorgente, i frammenti e le miniature verranno distrutti. Questa azione è irreversibile.',
  'detail.deleteStarted': 'Eliminazione avviata.',
  'detail.actionFailed': 'Azione non possibile al momento.',

  'settings.title': 'Account e privacy',
  'settings.subtitle': 'Cosa conserva BOOMSHOT e cosa non può garantire.',
  'settings.identity': 'Identità',
  'settings.anonymous': 'Account anonimo',
  'settings.memberSince': 'Iscritto dal {date}',
  'settings.dataKept': 'Dati conservati',
  'settings.dataKept1':
    "Dopo l'eliminazione di un video, BOOMSHOT conserva solo una traccia minima: stato, data di creazione, data di visione, data di eliminazione, durata e il nome che hai scelto.",
  'settings.dataKept2':
    'Non viene memorizzato alcun indirizzo IP completo. Non resta alcuna miniatura, alcun frammento video né alcun file sorgente.',
  'settings.limitsTitle': 'Limiti reali della protezione',
  'settings.limits1':
    'Un video riprodotto in un browser può sempre essere copiato: screenshot, registrazione dello schermo, una telecamera esterna che riprende lo schermo o estrazione da parte di un utente tecnicamente esperto.',
  'settings.limits2':
    'BOOMSHOT garantisce che un link apra esattamente una sessione di riproduzione e che i file vengano poi distrutti lato server. Non garantisce che l’immagine non possa essere copiata.',
  'settings.deleteAccount': "Elimina l'account",
  'settings.deleteAccountBody':
    'Tutti i tuoi video, link e file verranno distrutti. Questa azione è irreversibile.',
  'settings.deleteConfirmLabel': 'Digita ELIMINA per confermare',
  'settings.deleteConfirmWord': 'ELIMINA',
  'settings.deleteSubmit': 'Elimina definitivamente il mio account',
  'settings.deleted': 'Account eliminato.',
  'settings.signOutFailed': 'Impossibile disconnettersi al momento.',

  'viewer.checking': 'Verifica del link…',
  'viewer.preparing': 'Quasi pronto: il video del mittente è ancora in preparazione.',
  'viewer.eyebrow': 'Visione unica',
  'viewer.title': 'Questo video può essere visto una sola volta.',
  'viewer.subtitle':
    'Avvialo quando sei pronto e assicurati di avere una connessione stabile.',
  'viewer.sender': 'Mittente',
  'viewer.message': 'Messaggio',
  'viewer.duration': 'Durata',
  'viewer.deadline': 'Disponibile fino al',
  'viewer.warning':
    'Non appena avvii la riproduzione, il link diventerà definitivamente inutilizzabile. Non ci sarà replay, né riavvolgimento, né una seconda sessione - nemmeno se chiudi la pagina per sbaglio.',
  'viewer.start': 'Avvia la visione unica',
  'viewer.startWithPin': 'Conferma e avvia la visione unica',
  'viewer.pinHint': 'Il mittente ti ha comunicato questo codice separatamente.',
  'viewer.pinWrong': 'Codice errato.',
  'viewer.pinWrongRetry': 'Codice errato. Riprova tra {seconds} s.',
  'viewer.retryIn': 'Nuovo tentativo tra {seconds} s',
  'viewer.noPreload': 'Nessun frammento video viene caricato prima della tua conferma.',
  'viewer.checkFailed': 'Impossibile verificare questo link al momento.',
  'viewer.claimFailed': 'Non è stato possibile aprire la sessione di riproduzione.',
  'viewer.unavailable.title': 'Questo link non è più valido',
  'viewer.unavailable.body':
    'Potrebbe essere già stato usato o revocato, oppure non è mai esistito. Per motivi di riservatezza non possiamo dire di più. Chiedi un nuovo link al mittente.',
  'viewer.expired.title': 'Questo link è scaduto',
  'viewer.expired.body':
    'Il termine fissato dal mittente è passato e il video è stato eliminato. Chiedi un nuovo link se devi ancora vederlo.',
  'viewer.used.title': 'Questo video è già stato aperto',
  'viewer.used.body':
    'Per questo link è già stata avviata una sessione di riproduzione. Non può crearne un’altra e il video è stato eliminato.',
  'viewer.stillProcessing.title': 'Questo video è ancora in preparazione',
  'viewer.stillProcessing.body':
    'Questa operazione richiede più tempo del solito. Il link funziona correttamente: riaprilo tra qualche minuto e il video dovrebbe essere pronto.',
  'viewer.consumed.title': 'Video visto ed eliminato',
  'viewer.consumed.body':
    'La riproduzione è terminata. Il link è ormai inutilizzabile e i file sono stati distrutti sui nostri server.',
  'viewer.error.title': 'Riproduzione impossibile',

  'player.preloading': 'Precaricamento sicuro…',
  'player.tapToPlay': 'Tocca per riprodurre',
  'player.tapToPlayHint': 'La visione unica inizia non appena premi play.',
  'player.stalled': 'Connessione instabile - la riproduzione riprenderà automaticamente.',
  'player.play': 'Riproduci',
  'player.pause': 'Metti in pausa',
  'player.mute': 'Disattiva l’audio',
  'player.unmute': 'Riattiva l’audio',
  'player.volume': 'Volume',
  'player.fullscreen': 'Schermo intero',
  'player.exitFullscreen': 'Esci da schermo intero',
  'player.progress': 'Avanzamento della riproduzione',
  'player.unsupported': 'Il tuo browser non può riprodurre questo video.',
  'player.fatal': 'La riproduzione è stata interrotta e non può riprendere.',

  'notFound.title': 'Pagina non trovata',
  'notFound.body':
    'Questo indirizzo non corrisponde a nulla. Se hai ricevuto un link a un video, verifica che sia stato copiato per intero: la parte dopo il {hash} è indispensabile.',
  'notFound.home': 'Torna alla home',

  'apiError.network': 'Nessuna connessione. Controlla la rete.',
  'apiError.unauthenticated': 'Sessione scaduta. Accedi di nuovo.',
  'apiError.forbidden': 'Accesso negato.',
  'apiError.notFound': 'Non trovato.',
  'apiError.conflict': 'Questa azione è già stata eseguita.',
  'apiError.rateLimited': 'Troppi tentativi. Riprova tra poco.',
  'apiError.badResponse': 'Risposta inattesa dal server.',
  'apiError.internal': 'Qualcosa è andato storto dalla nostra parte.',
  'apiError.badRequest': 'Richiesta non valida.',

  'validation.required': 'Obbligatorio',
  'validation.invalidFormat': 'Formato non valido',
  'validation.tooLong': 'Troppo lungo',
  'validation.unsafeCharacters': 'Caratteri non consentiti',
  'validation.email': 'Indirizzo email non valido',
  'validation.passwordMin': 'Almeno 10 caratteri',
  'validation.passwordComplexity': 'Deve contenere una minuscola, una maiuscola e una cifra',
  'validation.passwordMismatch': 'Le password non coincidono',
  'validation.termsRequired': 'Devi accettare le condizioni',
  'validation.pinDigits': 'Il codice deve essere numerico',
  'validation.pinMin': 'Almeno {min} cifre',
  'validation.pinMax': 'Al massimo {max} cifre',
  'validation.messageTooLong': 'Messaggio troppo lungo (massimo 500 caratteri)',
  'validation.dateRequired': 'Scegli una data',
  'validation.dateTooSoon': 'La data deve essere almeno 5 minuti nel futuro',
  'validation.dateTooFar': 'La data non può superare i 30 giorni',
  'validation.confirmDelete': 'Digita ELIMINA per confermare',

  'state.errorTitle': 'Qualcosa è andato storto',
};
